// First-touch attribution — capturamos UTM params + referrer + path del landing
// la primera vez que un visitante toca la app, y los persistimos en localStorage
// hasta que se convierte en signup. En ese momento, el AuthProvider los lee y
// los manda al row de profiles (idempotente, solo si signup_source es null).

const KEY = "ranerzzz_attribution";

export interface Attribution {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  referrer?: string;
  landing_path?: string;
  captured_at: string;
}

export function captureAttribution() {
  // Solo capturar si NO hay ya una captura previa (first-touch attribution)
  if (typeof window === "undefined") return;
  if (localStorage.getItem(KEY)) return;

  const params = new URLSearchParams(window.location.search);
  const ref = document.referrer;
  let refDomain: string | undefined;
  try {
    if (ref) refDomain = new URL(ref).hostname;
  } catch {
    // referrer inválido — lo ignoramos.
  }

  const source =
    params.get("utm_source") ||
    (refDomain && refDomain !== window.location.hostname ? refDomain : undefined) ||
    "direct";

  const data: Attribution = {
    utm_source: source,
    utm_medium: params.get("utm_medium") ?? undefined,
    utm_campaign: params.get("utm_campaign") ?? undefined,
    referrer: ref || undefined,
    landing_path: window.location.pathname,
    captured_at: new Date().toISOString(),
  };

  try {
    localStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    // localStorage puede estar deshabilitado (modo privado, quota); ignoramos.
  }
}

export function readAttribution(): Attribution | null {
  if (typeof window === "undefined") return null;
  let raw: string | null = null;
  try {
    raw = localStorage.getItem(KEY);
  } catch {
    return null;
  }
  if (!raw) return null;
  try {
    return JSON.parse(raw) as Attribution;
  } catch {
    return null;
  }
}

export function clearAttribution() {
  if (typeof window === "undefined") return;
  try {
    localStorage.removeItem(KEY);
  } catch {
    // ignore
  }
}
